<template>
    <div class="bx">
        <headTitle />
        <div class="s-y" id="sy">
            <div class="left">

                <div class="text">
                    <div class="line" style="
  font-size: 26px;
  text-align: center;
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;">
                 All-New WEB3 AI Gaming Platform
                    </div>
                    <div style="
  font-size: 15px;
  font-weight: 400;
  color: #D1D1D1;
  margin-top: 2px;
  text-align: center;
  font-family: PingFang SC-Regular, PingFang SC;">PLAY WITH AI TO EARN</div>
                </div>
                <div class="title">
                    <img style="width: 300px;
  height: 200px;" src="../../pc/image/1.png" alt="">

                </div>
                <div class="btn-all">

                    <div class="btn1 btn" @click="open('https://app.wdp.app')">
                       Start

                    </div>
                    <div class="btn3 btn"  @click="open('https://docs.wdp.app/')">
                        <div class="btn2 ">
                            MORE
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="titles">
            <span style="color:#5780FF;font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
     font-size: 16px;
    line-height: 21px;">Compete against AI in games and earn money. Games include Pac-Man, Connect, and Tetris. Learn more.</span>
        </div>
        <div class="trade" id="trade">

            <div class="left">
                <img src="../../pc/image/7.png" alt="">
            </div>
            <div class="right">

                <div class="text">
                    <div class="list">
                        <img src="../../pc/image/15.png" alt="">Pacman
                    </div>
                    <div class="list">
                        <img src="../../pc/image/15.png" alt="">Snake
                    </div>
                    <div class="list">
                        <img src="../../pc/image/15.png" alt="">Tetris
                    </div>
                </div>
                <div class="btn">
                    Start
                    </div>
            </div>
        </div>



        <div class="s-y2" id="s-y2-2" style="

            background: rgba(84, 115, 206, 0.112);margin-top: 40px;margin-bottom: 40px;
            ">

            <div class="left" style=" width: 100%;">

                <div class="text">
                    <div class="line" style="
            font-size: 20px;
            text-align: center;
            line-height: 26px;
            font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
            font-weight: bold;
            color: #fff;
            ">
                       One-Stop WEB3 AI Gaming  <span style="color: #5780FF;">Platform</span>

                    </div>
                    <div style="
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            color: #D1D1D1;
            margin-top: 15px;
            text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;">Play games with AI, make games with AI, promote games with AI, and make money from all these activities</div>
                </div>
                <div class="center-box2">

                    <div class="box2">
                        <img src="../../pc/image/8.png" alt="">
                        <div class="cen">
                            <div class="text1">Play to earn</div>
                            <div class="text2">connect your wallet to start earning by playing games</div>
                        </div>



                    </div>
                    <div class="box2">
                        <div class="cen">

                            <div class="text1">Create and Publish Your Game Using AI</div>
                            <div class="text2">Use AI to create and publish games on the platform and enjoy high commission returns.</div>
                        </div>
                        <img src="../../pc/image/9.png" alt="">


                    </div>
                    <div class="box2">
                        <img src="../../pc/image/10.png" alt="">
                        <div class="cen">

                            <div class="text1">Utilize AI-Powered Marketing Assistant to Generate Personal Invitation Links</div>
                            <div class="text2">Generate exclusive invitation link</div>
                        </div>


                    </div>
                </div>

            </div>

        </div>


        <div class="earn2" id="earn2">
            <div class="left">
                <div class="title">
                    AI + Gaming: A New Model Changing Traditional Games. Experience the Brand New AI GAME-FI.
                </div>
                <div class="text">
                  The platform combines AI technology with game development techniques to create a brand-new AI gaming platform. By introducing AI technology into the WEB3 gaming domain, AI GAME-FI is set to represent the future of the gaming industry.

                </div>

            </div>
            <div class="right">
                <img src="../../pc/image/11.png" alt="">
            </div>
        </div>


        <div class="line" style="
  font-size: 26px;

  text-align: center;
  margin-bottom: 57px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
            Roadmap

          </div>
           <div class="step" >
  <div style="
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 1

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo"
   />
   <div class="leftall"></div>

          </div>

        </div>

           <div class="step" >
  <div style="
  font-size: 18px;

  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 2

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo2"
   />

   <div class="leftall"></div>
          </div>

        </div>
  
           <div class="step" >
  <div style="
  font-size: 18px;

  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 3

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo3"
   />
   <div class="leftall"></div>

          </div>

        </div>


        <div class="line" style="
  font-size: 26px;
  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
            Our <span style="color: #5780FF;">partner</span>

        </div>
        <div class="money">

            <div class="list">
                <img src="../../pc/image/2.png" alt="">
                <div class="title">Gate</div>

            </div>
            <div class="list">
                <img style="" src="../../pc/image/3.png" alt="">
                <div class="title">OKX</div>

            </div>
            <div class="list">
                <img src="../../pc/image/4.png" alt="">
                <div class="title">MECK</div>

            </div>
            <div class="list">
                <img src="../../pc/image/5.png" alt="">
                <div class="title">TokenPocket</div>

            </div>
            <div class="list">
                <img src="../../pc/image/6.png" alt="">
                <div class="title">Lemond</div>

            </div>
        </div>



        <div class="line" style="
  font-size: 26px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 40px;
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
             play to  <span style="color: #5780FF;">earn</span>

        </div>
        <div class="classbox2" id="classbox2">

            <div class="botton1" @click="open('https://t.me/wdpapperc20portal')">
                <img style="width: 18px;
height: 18px;" src="../../pc/image/t1.png" alt="">
                Telegram
            </div>
            <div class="botton1" @click="open('https://twitter.com/WDPAIGAMING')">
                <img style="width: 18px;
height: 18px;" src="../../pc/image/t2.png" alt="">
                Twitter
            </div>
            <div class="botton1" @click="open('https://docs.wdp.app')">
                <img style="width: 18px;
height: 18px;" src="../../pc/image/t3.png" alt="">

whitepaper
            </div>
        </div>
        <p class="emal">E-mail：Chavez@wdp.app</p>

    </div>
</template>

<script>
import Steps from '@/components/steps/indextwo.vue'

import headTitle from "./components/heat-title.vue";
export default {
    components: { headTitle,Steps },
    data () {
    return {
      stepInfo: {
					list: [{
							name: 'Game Developement'
						},
						{
							name: 'Whitepaper'
						},
						{
							name: 'Contract creation'
						},
            {
							name: 'Marketing & Community building'
						},
            {
							name: 'Pinksale Launch'
						},
					],

                   //步骤条进度
					step: 2
				},
      stepInfo2: {
					list: [{
							name: 'More Games intergration '
						},
						{
							name: 'AI-Powered Marketing Assistant'
						},
						{
							name: 'CEX Listing'
						},
            {
							name: 'Auditing'
						},
            {
							name: 'Partnership expansion'
						},
					],
          
                   //步骤条进度
					step: 2
				},
        stepInfo3: {
					list: [{
							name: 'Game Developement  Assistant'
						},
						{
							name: 'NFT Listing'
						},
						{
							name: 'Expanding the Team'
						},
            {
							name: 'Participation in Summits'
						},
           
					],
          
                   //步骤条进度
					step: 2
				},
    }
},


    mounted() {
    },
    methods:{
    open(url){
      window.location.href=url
    }
  },
};
</script>

<style lang="less" scoped>
.step{
  padding: 0 5%;
  margin-bottom: 100px;
}
.step-box{
  position: relative;

background: rgba(84,114,206,0.2);
border-radius: 24px 24px 24px 24px;
opacity: 1;
padding: 20px;
border: 1px solid #5472CE;

.leftall{
  width: 200px;
height: 4px;
background: #5780FF;
border-radius: 24px 24px 24px 24px;
opacity: 1;
position: absolute;
left: 20%;
top: 0px;
}
}
.emal{
    color: #fff;
    text-align: center;
    font-size: 14px;
    padding-bottom: 100px;

}
.s-y {
    display: flex;
    justify-content: center;
    background: url("../../pc/image/12.png") no-repeat;
    background-size: cover;
    background-size: 100% 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    /*关键*/
    background-position: center;


    .left {
        padding-top: 12px;

        .title {
            display: flex;
            justify-content: center;

        }

        .text {
            margin-top: 33px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            >div {
                font-family: Flynn mono VF;
                font-size: 24px;
                font-weight: normal;
                line-height: 40px;
                color: #fff;
            }
        }

        .btn-all {
            margin-top: 42px;
            display: flex;
            justify-content: center;

            .btn1 {
                width: 120px;
                height: 70px;
                background: #5780FF;
                background: linear-gradient(127deg, transparent 20px, #5780FF 0%, #1434E1 100%) top left,
                    linear-gradient(-135deg, #5780FF 0%, #1434E1 100%) top right,
                    linear-gradient(-45deg, transparent 20px, #5780FF 0%, #1434E1 100%) bottom right,
                    linear-gradient(45deg, #5780FF 5%, #1434E1 100%) bottom left;
                background-size: 50% 50%;
                background-repeat: no-repeat;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Flynn mono VF;
                font-size: 12px;
                font-weight: normal;
                line-height: 30px;
                text-align: center;

                color: #FFFFFF;
                // border-top-left-radius: 30px;
                // border-bottom-right-radius: 30px;
                margin-right: 48px;
                cursor: pointer;
            }

            .btn3 {
                display: flex;

                align-items: center;

                justify-content: center;

                padding: 2px;

                background: linear-gradient(-45deg, transparent 20px, #5780FF 0) bottom right,

                    linear-gradient(45deg, transparent 0px, #5780FF 0) bottom left,

                    linear-gradient(135deg, transparent 20px, #5780FF 0) top left,

                    linear-gradient(-135deg, transparent 0px, #5780FF 0) top right;

                background-size: 50% 50%;

                background-repeat: no-repeat;
            }

            .btn2 {
                width: 120px;
                height: 70px;

                opacity: 1;
                box-sizing: border-box;
                background: linear-gradient(-45deg, transparent 20px, #070707 0) bottom right,

                    linear-gradient(45deg, transparent 0px, #070707 0) bottom left,

                    linear-gradient(135deg, transparent 20px, #070707 0) top left,

                    linear-gradient(-135deg, transparent 0px, #070707 0) top right;

                background-size: 50% 50%;

                background-repeat: no-repeat;
                color: #5780FF;
                font-family: Flynn mono VF;
                font-size: 12px;
                font-weight: normal;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
    }

    .right {
        position: relative;
        width: 866px;
        // background: url('.../../pc/image/b001.png') no-repeat;

        .bei-qu {
            position: absolute;
            width: 860.53px;
            height: 391.44px;
            top: 126px;
            left: 14px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .zhu {
            position: absolute;
            width: 334px;
            height: 200px;
            top: 41px;
            left: 120px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .bai {
            position: absolute;
            width: 116px;
            height: 116px;
            top: 5px;
            left: 571px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .zhe {
            position: absolute;
            width: 281px;
            height: 181px;
            left: 510px;
            top: 150px;

            img {
                width: 100%;
                height: 100%;
            }
        }


        .dian1 {
            left: 76px;
            top: 142px;
        }

        .dian2 {
            left: 807px;
            top: 219px;
        }

        .diy {
            position: absolute;
            top: 299px;
            left: 254px;
            width: 163px;
            height: 105px;
            border-radius: 5px;
            background: rgba(255, 255, 255, 0.01);
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.01);
            backdrop-filter: blur(8.29px);
            box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.16);

            .bei {
                width: 100%;
                height: 100%;
                border: 0.5px solid #FFFFFF;
                background: rgba(255, 255, 255, 0.01);
                filter: blur(1.8px);
                box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
            }

            .qiu {
                border-radius: 50%;
                width: 26px;
                height: 26px;
                background: linear-gradient(136deg, #26FF93 14%, #F4E634 133%);
                box-shadow: 0px 3px 6px 0px rgba(4, 13, 8, 0.5), inset -5px -5px 6px 0px rgba(66, 77, 71, 0.5);
                position: absolute;
                right: 17px;
                top: 17px;
            }

            .tiao1 {
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                width: 79px;
                height: 8px;
                border-radius: 6px;
                position: absolute;
                left: 16px;
                top: 41px;
            }

            .tiao2 {
                background: #FFFFFF;
                position: absolute;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                width: 130px;
                height: 8px;
                border-radius: 6px;
                left: 16px;
                top: 73px;
            }
        }
    }
}


.titles {
    text-align: center;
    margin-top: 40px;
}

.trade {
    display: flex;
    align-items: center;
    border-radius: 20px;
    opacity: 1;

    img {
        width: 165px;
        height: 180px;
    }

    .left {
        flex: 1;
        display: flex;
        align-items: center;
        position: relative;

        .dian1 {
            left: 109px;
            top: calc(436px - 276px);
        }

        .dian2 {
            left: 514px;
            top: calc(203px - 276px);
        }

        .main {
            width: 800px;
            height: 364px;
            position: relative;


            .di {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 554px;
                height: 332px;
                border-radius: 20px;
                opacity: 0.41;
                background: linear-gradient(125deg, #25B06B 13%, #F4E634 110%);
                box-shadow: inset 10px 10px 10px 0px rgba(0, 0, 0, 0.3);
            }

            .main-zhu-ti {
                position: absolute;
                top: 0;
                right: 0;
                width: 554px;

                .top {
                    width: 554px;
                    height: 28px;
                    border-radius: 16px 16px 0px 0px;
                    background: linear-gradient(93deg, #25B06B 12%, #F4E634 106%);
                    box-shadow: inset 0px 3px 6px 0px #395748;
                    padding-left: 16px;
                    padding-top: 10px;
                    display: flex;
                    box-sizing: border-box;

                    .r {
                        margin-right: 8px;
                        width: 12px;
                        height: 12px;
                        opacity: 1;
                        background: #ED6C60;
                        box-sizing: border-box;
                        border: 1px solid #2D9561;
                        box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                        border-radius: 50%;
                    }

                    .y {
                        margin-right: 8px;
                        width: 12px;
                        height: 12px;
                        background: #F4E634;
                        box-sizing: border-box;
                        border: 1px solid #2D9561;
                        box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                        border-radius: 50%;
                    }

                    .b {
                        width: 12px;
                        height: 12px;
                        background: #62C555;
                        box-sizing: border-box;
                        border: 1px solid #2D9561;
                        box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                        border-radius: 50%;
                    }
                }

                .main-zhong {
                    width: 554px;
                    height: 304px;
                    border-radius: 0px 0px 20px 20px;
                    background: linear-gradient(118deg, #192214 0%, #566456 97%);
                    box-shadow: 0px -3px 3px 0px rgba(0, 0, 0, 0.3);
                    display: flex;

                    .main-zhong-left {
                        box-sizing: border-box;
                        padding-left: 22px;
                        margin-right: 6px;

                        .top-zui-shang {
                            height: 152px;
                            display: flex;
                            align-items: center;
                            padding-left: 15px;

                            .zuo-you {
                                padding-top: 30px;

                                .text {
                                    margin-bottom: 17px;
                                    font-family: Flynn mono VF;
                                    font-size: 18px;
                                    font-weight: normal;
                                    line-height: 18px;
                                    color: #FFFFFF;
                                }

                                .bi {
                                    display: flex;
                                    align-items: center;

                                    img {
                                        width: 24px;
                                        height: 24px;
                                        margin-right: 10px;
                                    }

                                    .t {
                                        opacity: 0.8;
                                        font-family: Flynn mono VF;
                                        font-size: 12px;
                                        font-weight: normal;
                                        line-height: 12px;
                                        color: #FFFFFF;
                                    }
                                }

                                .title-img {
                                    margin-top: 19px;
                                    width: 44px;
                                    height: 44px;
                                    border-radius: 10px;
                                }

                                .left-color {
                                    background: #FFC600;
                                }

                                .right-color {
                                    background: #6FDAF0;
                                }
                            }

                            .left-zhong {
                                height: 100%;
                                display: flex;
                                flex-direction: column-reverse;
                                padding-left: 17px;
                                padding-right: 50px;

                                img {
                                    width: 36px;
                                    height: 36px;
                                }
                            }
                        }

                        .xian {
                            margin-top: 25px;
                            margin-bottom: 17px;
                            width: 342px;
                            height: 0px;
                            opacity: 0.1;
                            border: 1px solid #FFFFFF;
                        }

                        .ms {
                            display: flex;
                            opacity: 0.8;
                            font-family: Flynn mono VF;
                            font-size: 10px;
                            font-weight: normal;
                            line-height: 12px;
                            color: #FFFFFF;
                            margin-bottom: 17px;

                            .t1 {
                                margin-right: 23px;
                            }
                        }

                        .btn {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 313px;
                            height: 57px;
                            border-radius: 10px;
                            opacity: 1;
                            background: linear-gradient(102deg, #25B06B 12%, #F4E634 106%);
                            font-family: Flynn mono VF;
                            font-size: 18px;
                            font-weight: normal;
                            line-height: 18px;
                            text-align: center;
                            color: #0F0F0F;
                        }
                    }

                    .main-zhong-right {
                        padding-right: 21px;
                        padding-top: 17px;

                        .main-zhong-right-zhu-ti {
                            width: 162px;
                            box-sizing: border-box;
                            height: 100%;
                            border-radius: 10px 10px 0 0;
                            background: rgba(30, 40, 26, 0.28);
                            padding: 20px 12px 0;

                            .title {
                                font-family: Flynn mono VF;
                                font-size: 18px;
                                font-weight: normal;
                                line-height: 18px;
                                color: #FFFFFF;
                                text-align: center;
                                margin-bottom: 18px;
                            }

                            .xian {
                                width: 137.5px;
                                height: 0px;
                                opacity: 0.1;
                                border: 1px solid #FFFFFF;
                            }

                            >.list {
                                display: flex;
                                align-items: center;
                                margin-top: 19px;

                                .t {
                                    opacity: 0.8;
                                    font-family: Flynn mono VF;
                                    font-size: 12px;
                                    font-weight: normal;
                                    line-height: 14px;
                                    color: #FFFFFF;
                                }

                                img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 12px;
                                }
                            }
                        }
                    }
                }
            }

            .an-quan-img {
                width: 80px;
                height: 80px;
                position: absolute;
                top: 41px;
                left: 571px;
                overflow: hidden;

                img {
                    width: 90px;
                    height: 90px;
                    transform: translate(-8px);
                }
            }

            .yi-biao {
                width: 174px;
                height: 116px;
                position: absolute;
                top: 294px;
                left: 357px;
            }
        }
    }

    .right {
        flex: 1;

        .title {
            font-family: Flynn mono VF;
            font-size: 16px;
            font-weight: normal;
            color: #fff;
        }

        .text {
            margin-top: 40px;

            >div {
                display: flex;
                align-items: center;
                white-space: nowrap;
                margin-top: 15px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #D1D1D1;

                img {
                    width: 18px;
                    height: 18px;
                    margin-right: 5px;
                }
            }

            >div:first-child {
                margin-top: 0;
            }
        }

        .btn {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 100px;
            height: 40px;
            background: linear-gradient(127deg, #5780FF 0%, #1434E1 100%);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 2px solid #082F64;
            font-size: 12px;
            font-weight: normal;
            line-height: 30px;
            color: #0F0F0F;
        }
    }
}


.s-y2 {
    // display: flex;
    // justify-content: space-between;
    padding-top: 0px;
    margin-top: 20px;

    // height: 600px;

    .left {
        padding-top: 12px;

        .title {
            display: flex;
            justify-content: center;

        }

        .text {
            margin-top: 10px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            >div {
                font-family: Flynn mono VF;
                font-size: 24px;
                font-weight: normal;
                line-height: 22px;
                color: #fff;
            }
        }

        .btn-all {
            margin-top: 42px;
            display: flex;
            justify-content: center;

            .btn1 {
                width: 230px;
                height: 82px;
                border-radius: 10px;

                background: linear-gradient(127deg, #5780FF 0%, #1434E1 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Flynn mono VF;
                font-size: 24px;
                font-weight: normal;
                line-height: 30px;
                text-align: center;

                color: #FFFFFF;
                border-top-left-radius: 30px;
                border-bottom-right-radius: 30px;
                margin-right: 48px;
                cursor: pointer;
            }

            .btn2 {
                width: 230px;
                height: 82px;
                border-radius: 10px;
                opacity: 1;
                box-sizing: border-box;
                border-top-left-radius: 30px;
                border-bottom-right-radius: 30px;
                border: 2px solid #5780FF;

                color: #5780FF;
                font-family: Flynn mono VF;
                font-size: 24px;
                font-weight: normal;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
    }

    .right {
        position: relative;

        // background: url('.../../pc/image/b001.png') no-repeat;

        .bei-qu {
            position: absolute;
            width: 860.53px;
            height: 391.44px;
            top: 126px;
            left: 14px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .zhu {
            position: absolute;
            width: 334px;
            height: 200px;
            top: 41px;
            left: 120px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .bai {
            position: absolute;
            width: 116px;
            height: 116px;
            top: 5px;
            left: 571px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .zhe {
            position: absolute;
            width: 281px;
            height: 181px;
            left: 510px;
            top: 150px;

            img {
                width: 100%;
                height: 100%;
            }
        }


        .dian1 {
            left: 76px;
            top: 142px;
        }

        .dian2 {
            left: 807px;
            top: 219px;
        }

        .diy {
            position: absolute;
            top: 299px;
            left: 254px;
            width: 163px;
            height: 105px;
            border-radius: 5px;
            background: rgba(255, 255, 255, 0.01);
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.01);
            backdrop-filter: blur(8.29px);
            box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.16);

            .bei {
                width: 100%;
                height: 100%;
                border: 0.5px solid #FFFFFF;
                background: rgba(255, 255, 255, 0.01);
                filter: blur(1.8px);
                box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
            }

            .qiu {
                border-radius: 50%;
                width: 26px;
                height: 26px;
                background: linear-gradient(136deg, #26FF93 14%, #F4E634 133%);
                box-shadow: 0px 3px 6px 0px rgba(4, 13, 8, 0.5), inset -5px -5px 6px 0px rgba(66, 77, 71, 0.5);
                position: absolute;
                right: 17px;
                top: 17px;
            }

            .tiao1 {
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                width: 79px;
                height: 8px;
                border-radius: 6px;
                position: absolute;
                left: 16px;
                top: 41px;
            }

            .tiao2 {
                background: #FFFFFF;
                position: absolute;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                width: 130px;
                height: 8px;
                border-radius: 6px;
                left: 16px;
                top: 73px;
            }
        }
    }
}


.center-box2 {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 0px;

    .pai {
        position: absolute;
        left: 44%;
        top: -20px;
        width: 36px !important;
        height: 36px !important;
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        font-size: 30px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 319px;
        height: 380px;
        background: rgba(84, 114, 206, 0.2);
        border-radius: 24px 24px 24px 24px;
        opacity: 1;
        border: 1px solid #5472CE;

        img {
            width: 80px;
            height: 80px;
        }

        .text1 {
            font-size: 20px;
            font-family: Galvji-Bold, Galvji;
            font-weight: bold;
            color: #FFFFFF;
            margin-top: 30px;
        }

        .text2 {
            font-size: 24px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D1D1D1;
            margin-top: 18px;
            width: 200px;
        }
    }

    .box2 {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        opacity: 1;

        img {
            width: 80px;
            height: 80px;
        }

        .cen {
            margin: 0 10px
        }

        .text1 {
            font-size: 16px;
            font-family: Galvji-Bold, Galvji;
            font-weight: bold;
            color: #FFFFFF;
            margin-top: 10px;
            line-height: 22px;


        }

        .text2 {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D1D1D1;
            margin-top: 10px;
            line-height: 20px;
            text-align: left;
        }
    }
}


.earn2 {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    align-items: center;
    margin-bottom: 30px;
    margin-top: 30px;

    .left {
        box-sizing: border-box;
        // padding-top: 253px;
        // flex: 1;
        padding-left: 7px;

        .title {
            font-size: 16px;
            line-height: 24px;
            font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
            font-weight: bold;
            text-align: center;
            color: #FFFFFF;
        }

        .text {
            margin-top: 10px;
            font-size: 12px;
            line-height: 20px;

            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D1D1D1;
            text-align: center;
        }

        .btn {
            margin-top: 52px;
            width: 280px;
            height: 80px;
            border-radius: 10px;
            opacity: 1;
            background: linear-gradient(106deg, #25B06B 0%, #F4E634 107%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Flynn mono VF;
            font-size: 30px;
            font-weight: normal;
            line-height: 30px;
            text-align: center;
            color: #0F0F0F;
            cursor: pointer;
        }

    }

    .right {
        flex: 1;
        box-sizing: border-box;
        padding-top: 0px;
        position: relative;
        padding-left: 0px;

        img {
            width: 100%;
            height: 100%;
        }

        .bei-qu {
            position: absolute;
            width: 913.2px;
            height: 700.46px;
            top: 204px;
            left: -110px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .dian1 {
            left: 48px;
            top: 499px;
        }

        .dian2 {
            left: 761px;
            top: 233px;
        }

        .main {
            position: relative;
            z-index: 9;
            width: 554px;

            .top {
                width: 554px;
                height: 28px;
                border-radius: 16px 16px 0px 0px;
                background: linear-gradient(93deg, #25B06B 12%, #F4E634 106%);
                box-shadow: inset 0px 3px 6px 0px #395748;
                padding-left: 16px;
                padding-top: 10px;
                display: flex;
                box-sizing: border-box;

                .r {
                    margin-right: 8px;
                    width: 12px;
                    height: 12px;
                    opacity: 1;
                    background: #ED6C60;
                    box-sizing: border-box;
                    border: 1px solid #2D9561;
                    box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                    border-radius: 50%;
                }

                .y {
                    margin-right: 8px;
                    width: 12px;
                    height: 12px;
                    background: #F4E634;
                    box-sizing: border-box;
                    border: 1px solid #2D9561;
                    box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                    border-radius: 50%;
                }

                .b {
                    width: 12px;
                    height: 12px;
                    background: #62C555;
                    box-sizing: border-box;
                    border: 1px solid #2D9561;
                    box-shadow: inset -3px -3px 2px 0px rgba(41, 4, 4, 0.3);
                    border-radius: 50%;
                }
            }

            .main-zhu {
                width: 554px;
                height: 403px;
                border-radius: 0px 0px 20px 20px;
                background: linear-gradient(360deg, #192214 0%, #566456 99%);
                box-shadow: 0px -3px 3px 0px rgba(0, 0, 0, 0.3);
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 149px;
                box-sizing: border-box;

                .tiao {
                    width: 200px;
                    height: 8px;
                    border-radius: 6px;
                    opacity: 1;
                    background: #FFFFFF;
                    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                    margin-bottom: 26px;
                }

                .list {
                    width: 235px;
                    height: 48px;
                    border-radius: 6px;
                    background: rgba(255, 255, 255, 0.2);
                    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset 0px -2px 3px 0px #FFFFFF;
                    margin-bottom: 20px;
                    padding: 16px;
                    box-sizing: border-box;

                    .t {
                        opacity: 0.5;
                        font-family: Flynn mono VF;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: 14px;
                        letter-spacing: 0em;
                        color: #D1D1D1;
                    }
                }
            }
        }

        .btn {
            position: absolute;
            left: 435px;
            top: 699px;
            width: 115px;
            height: 50px;
            border-radius: 6px;
            opacity: 1;
            background: linear-gradient(114deg, #25B06B 1%, #F4E634 108%);
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset 3px 3px 6px 0px rgba(255, 255, 255, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Flynn mono VF;
            font-size: 18px;
            font-weight: normal;
            line-height: 18px;
            text-align: center;
            letter-spacing: 0em;
            color: #0F0F0F;
            cursor: pointer;
        }

        .gui {
            position: absolute;
            left: 669px;
            top: 569px;
            width: 100px;
            height: 100px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .kuai-tiao {
            position: absolute;
            left: 111px;
            top: 472px;
            width: 115px;
            height: 145px;
            border-radius: 6px;
            background: linear-gradient(142deg, #25B06B 7%, #F4E634 115%);
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset 3px 3px 6px 0px rgba(255, 255, 255, 0.5);
            padding-left: 16px;
            padding-top: 81px;
            box-sizing: border-box;

            .tiao1 {
                width: 53px;
                height: 8px;
                border-radius: 6px;
                opacity: 1;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
                margin-bottom: 18px;
            }

            .tiao2 {
                width: 84px;
                height: 8px;
                border-radius: 6px;
                opacity: 1;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset -1px -2px 6px 0px #7EA896;
            }
        }

        .s-c {
            position: absolute;
            left: 38px;
            top: 354px;
            width: 188px;
            height: 60px;
            border-radius: 6px;
            opacity: 1;
            background: rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(10.36px);
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16), inset 0px -2px 6px 0px rgba(255, 255, 255, 0.2);
            padding: 18px 21px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .ss {
                width: 28px;
                height: 28px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .c {
                width: 24px;
                height: 24px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}


.money {
    margin-top: 10px;
    margin-bottom: 20px;
    height: 35px;

    background: #5781ff17;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    justify-content: space-around;

    .list {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 12px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
        }

        img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
            margin-left: 5px;

        }

        .text {
            >.line {
                font-family: Flynn mono VF;
                font-size: 18px;
                font-weight: normal;
                line-height: 24px;
                text-align: center;
                color: #D1D1D1;
                padding: 0 165px;
            }
        }
    }
}

.classbox2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 50px;

    .botton1 {
        margin-bottom: 10px;
        width: 133px;
        height: 39px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        border: 1px solid #717171;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        cursor: pointer;
    }

    img {
        margin-right: 10px;
    }

}</style>